document.addEventListener('wpcf7mailsent', function () {
    if (!event.target.closest('.js-nl-modal')) return;

    const formModal = document.querySelector('.js-nl-modal');
    const thanksModal = document.querySelector('.js-nl-thanks');
    if (formModal) formModal.setAttribute('aria-hidden', 'true');
    if (thanksModal) {
        thanksModal.setAttribute('aria-hidden', 'false');
        document.documentElement.classList.add('nl-lock');
    }
}, false);

document.addEventListener('click', (e) => {
    const openBtn = e.target.closest('.js-nl-open');
    if (openBtn) {
        const modal = document.querySelector('.js-nl-modal');
        if (modal) { modal.setAttribute('aria-hidden', 'false'); document.documentElement.classList.add('nl-lock'); }
        e.preventDefault(); return;
    }
    const closeBtn = e.target.closest('.js-nl-close');
    if (closeBtn) {
        document.querySelectorAll('.nl-modal').forEach(m => m.setAttribute('aria-hidden', 'true'));
        document.documentElement.classList.remove('nl-lock');
        e.preventDefault();
    }
});
